module.exports = __webpack_public_path__ + "img/loader.23d797c8.svg";